import { API_ENDPOINTS } from "./constants";

let textDetectionInProgress = false;
let audioDetectionInProgress = false;

const normalizeLang = (lang) =>
  typeof lang === "string" && lang.trim() ? lang.trim() : "en";

/**
 * TEXT LANGUAGE DETECTION (PURE)
 */
export async function textLanguageDetection({ query, sendRequest }) {
  if (textDetectionInProgress) return "en";
  textDetectionInProgress = true;

  try {
    return await new Promise((resolve) => {
      sendRequest({
        method: "POST",
        url: API_ENDPOINTS.languageDetection,
        headers: { "Content-Type": "application/json" },
        body: { query },
        abortable: true,
        isEncrypted: true,
        onSuccess: (res) => resolve(normalizeLang(res?.lang)),
        onError: () => resolve("en"),
      });
    });
  } finally {
    textDetectionInProgress = false;
  }
}

/**
 * AUDIO LANGUAGE DETECTION (PURE, SAME sendRequest)
 */
export async function audioLanguageDetection({
  audioBase64,
  sendRequest,
  samplingRate = 16000,
}) {
  if (audioDetectionInProgress) return "en";
  audioDetectionInProgress = true;

  try {
    return await new Promise((resolve) => {
      sendRequest({
        method: "POST",
        url: import.meta.env.VITE_BHASHINI_ENDPOINT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: import.meta.env.VITE_BHASHINI_API_KEY,
        },
        body: {
          pipelineTasks: [
            {
              taskType: "audio-lang-detection",
              config: {
                serviceId: import.meta.env.VITE_BHASHINI_ALD_SERVICE_ID,
                preprocessors: ["audio_enhancement"],
                language: { targetLanguage: "auto" },
              },
            },
          ],
          inputData: {
            audio: [
              {
                audioContent: audioBase64,
                audioFormat: "wav",
                samplingRate,
                channels: 1,
              },
            ],
          },
        },
        abortable: true,
        isEncrypted: false,
        onSuccess: (res) => {
          const lang =
            res?.pipelineResponse?.[0]?.output?.[0]?.langPrediction?.[0]
              ?.langCode;
          resolve(normalizeLang(lang));
        },
        onError: () => resolve("en"),
      });
    });
  } finally {
    audioDetectionInProgress = false;
  }
}

/**
 * SINGLE ENTRY POINT (PURE)
 */
export async function resolveLanguage({
  journeyType, // "TEXT" | "VOICE"
  textOptions,
  audioOptions,
}) {
  if (journeyType === "VOICE") {
    return audioLanguageDetection(audioOptions);
  }

  return textLanguageDetection(textOptions);
}
